module.exports = __webpack_public_path__ + "static/media/address.41e24872.svg";